import axios from "axios";
import { useEffect, useState } from "react";

import CartaoFidelidade from "./CartaoFidelidade";

/**
 * O cartão na tela de acompanhamento do pedido (cardápio, Mesa QR, Totem): se
 * este pedido carimbou, o carimbo novo desce com animação (decisão do dono:
 * "quando finalizar a compra... o cartão fidelidade deve aparecer com uma
 * animação"). Pedido sem carimbo (cliente sem cadastro, canal desligado,
 * abaixo do mínimo) não mostra nada.
 */
export default function CartaoNoAcompanhamento({ pedidoId, darkMode = false, className = "" }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    if (!pedidoId) return undefined;
    let vivo = true;
    // um pequeno atraso: o carimbo é gravado logo depois de o pedido nascer
    const t = setTimeout(() => {
      axios.get(`/api/public/fidelidade/pedido/${pedidoId}`).then((r) => vivo && setD(r.data)).catch(() => {});
    }, 900);
    return () => { vivo = false; clearTimeout(t); };
  }, [pedidoId]);

  if (!d?.carimbo_novo || !d.cartao?.participa) return null;
  const c = d.cartao;
  const completou = c.carimbos >= c.total;
  const premio = c.premio?.texto || "o prêmio";
  return (
    <section className={`p-3 sm:p-4 ${className || `rounded-2xl ${darkMode ? "bg-white/5" : "bg-black/[0.03]"}`}`} data-e2e="cartao-acompanhamento">
      <p className={`text-center font-bold mb-2.5 ${darkMode ? "text-white" : "text-gray-900"}`}>
        {completou ? "🎉 Você completou o cartão fidelidade!" : "✅ Mais um carimbo no seu cartão!"}
      </p>
      <CartaoFidelidade loja={d.loja} cartao={c} carimboNovo={d.carimbo_novo} />
      <p className={`text-center text-sm mt-2.5 ${darkMode ? "text-white/70" : "text-gray-600"}`}>
        {completou
          ? <>Seu prêmio, <b>{premio}</b>, fica liberado assim que este pedido for concluído.</>
          : <>Falta{c.faltam === 1 ? "" : "m"} só <b>{c.faltam}</b> para ganhar <b>{premio}</b>.</>}
      </p>
    </section>
  );
}
